import { FCC } from "@/types/common";
import { useCaseEditForm } from "@/features/case/hooks/use-case-edit-form";
import { CaseEditFormLayout } from "@/features/case/components/CaseEdit/CaseEditFormLayout";

export const CaseEditPage: FCC = () => {
  const {
    methods,
    caseSchema,
    onSubmit,
    hasStatusChanges,
    hasBasicInfoChanges,
    hasChangedStatusWithMissingFields,
    jobInfo,
    caseInfo,
    activeStep,
    managementNumber,
    caseMatchesData,
    total,
    countItem,
    totalPage,
    handleStatusMapChange,
    handleTalentStatusMapChange,
    handleDeleteCaseMatch,
    handleCaseMatchMissingFieldsUpdate,
    canEdit,
    isCompleted,
    isPersonInChargeLocked,
    isSubmitting,
    isSavingCaseMatchStatus,
    formatTotal,
    handleNavigateBack,
    handleNavigateCreateCase,
    onSaveBasicInfo,
    onAutoSaveCaseMatchStatus,
    onAutoSaveMemo,
    caseMatchFilterParams,
    setCaseMatchFilterParams,
    duplicateCaseModal,
    duplicateCases,
    pendingCaseName,
    jobId,
    caseExists,
    isSoftDeleting,
  } = useCaseEditForm();

  // Don't render form layout until case existence is confirmed
  // This prevents child components from making API calls for non-existent case.
  // Also unmount during soft-delete redirect so the leave-page blocker disappears
  // before navigation runs (see useCaseEditForm's softDeletedRedirectJobId effect).
  if (!caseExists || isSoftDeleting) {
    return null;
  }

  return (
    <CaseEditFormLayout
      methods={methods}
      caseSchema={caseSchema}
      onSubmit={onSubmit}
      hasStatusChanges={hasStatusChanges}
      hasBasicInfoChanges={hasBasicInfoChanges}
      hasChangedStatusWithMissingFields={hasChangedStatusWithMissingFields}
      jobInfo={jobInfo}
      caseInfo={caseInfo}
      activeStep={activeStep}
      managementNumber={managementNumber}
      caseMatchesData={caseMatchesData}
      total={total}
      countItem={countItem}
      totalPage={totalPage}
      onStatusMapChange={handleStatusMapChange}
      onTalentStatusMapChange={handleTalentStatusMapChange}
      onDeleteCaseMatch={handleDeleteCaseMatch}
      onCaseMatchMissingFieldsUpdate={handleCaseMatchMissingFieldsUpdate}
      canEdit={canEdit}
      isCompleted={isCompleted}
      isPersonInChargeLocked={isPersonInChargeLocked}
      isSubmitting={isSubmitting}
      isSavingCaseMatchStatus={isSavingCaseMatchStatus}
      formatTotal={formatTotal}
      onNavigateBack={handleNavigateBack}
      onNavigateCreateCase={handleNavigateCreateCase}
      onSaveBasicInfo={onSaveBasicInfo}
      onAutoSaveCaseMatchStatus={onAutoSaveCaseMatchStatus}
      onAutoSaveMemo={onAutoSaveMemo}
      caseMatchFilterParams={caseMatchFilterParams}
      onCaseMatchFilterParamsChange={setCaseMatchFilterParams}
      duplicateCaseModalOpen={duplicateCaseModal.open}
      duplicateCases={duplicateCases}
      pendingCaseName={pendingCaseName}
      onDuplicateCaseModalClose={() => duplicateCaseModal.cancel()}
      jobId={Number(jobId)}
    />
  );
};
